import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OrderView from "./OrderView";
import DemoDataService from "../services/demo.service";

const DemoView: React.FC = () => {
  const [orderId, setOrderId] = useState<string | number>("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    DemoDataService.get()
      .then((response) => {
        setOrderId(response.data.orderId);
        setLoading(false);
      })
      .catch(() => {
        setError("The demo table is unavailable right now.");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="container mt-5 text-center">Setting the table...</div>;
  }

  if (error || !orderId) {
    return (
      <div className="container mt-5 text-center">
        <p>{error || "The demo table is unavailable right now."}</p>
        <Link to="/">Back to the site</Link>
      </div>
    );
  }

  return (
    <OrderView orderId={orderId} currentURL="/demo" userData={null} />
  );
};

export default DemoView;
